import { QCCATSessionStorage } from "../api/qccatStorage";

export class QCCATClaims {
	public static userHasClaim = (claim: string) : boolean => {
		let user = QCCATSessionStorage.getUser();
		return (user) ? user.user.claims.indexOf(claim) >= 0 : false;
	}
}